export default {
  summary_one: '{{count}} item verwijderd · niet beschikbaar voor je afhaaltijd',
  summary_other: '{{count}} items verwijderd · niet beschikbaar voor je afhaaltijd',
  reason: 'Alleen bestelbaar {{schedule}} — je afhaling is om {{time}}.',
  change_pickup_time: 'Afhaaltijd wijzigen',
  dismiss: 'Sluiten',
};
